export const SET_SIMPLE_CALENDAR_CHOSEN_DATE =
  "auth/SET_SIMPLE_CALENDAR_CHOSEN_DATE";
export const SET_WARNING_SHOW_STATE = "auth/SET_WARNING_SHOW_STATE";
export const SET_IS_MOBILE = "auth/SET_IS_MOBILE";
